/**
 * FormSelect Component
 *
 * Custom styled select using Radix UI.
 */

import React from "react";
import * as Select from "@radix-ui/react-select";
import Icon from "../Icon";
import * as styles from "./FormSelect.module.scss";

const FormSelect = ({ availableValues, value, onValueChange, id }) => {
  return (
    <Select.Root value={value} onValueChange={onValueChange}>
      <Select.Trigger className={styles.trigger} id={id}>
        <Select.Value placeholder="Select a subject" />
        <Select.Icon className={styles.icon}>
          <Icon name="chevronDown" size="1.2em" />
        </Select.Icon>
      </Select.Trigger>

      <Select.Portal>
        <Select.Content className={styles.content} position="popper" sideOffset={4}>
          <Select.Viewport className={styles.viewport}>
            {availableValues.map(option => (
              <Select.Item key={option} value={option} className={styles.item}>
                <Select.ItemText>{option}</Select.ItemText>
                <Select.ItemIndicator className={styles.itemIndicator}>
                  <Icon name="check" size="1em" />
                </Select.ItemIndicator>
              </Select.Item>
            ))}
          </Select.Viewport>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};

export default FormSelect;
